module.exports = __webpack_public_path__ + "img/white_civil.d44828f6.svg";